import { __extends } from "tslib";
import React from 'react';
import { Slider, TextLabel, Composites, InfoIcon } from '@wix/wix-base-ui';
import { debounce } from '../../utils';
var SliderLabeled = /** @class */ (function (_super) {
    __extends(SliderLabeled, _super);
    function SliderLabeled(props) {
        var _this = _super.call(this, props) || this;
        _this.handleValueChange = debounce(function (value) {
            _this.props.onChange(value);
        }, 200);
        _this.handleInnerValueChange = function (value) {
            _this.setState({
                value: value,
            });
            _this.handleValueChange(value);
        };
        _this.state = {
            value: props.value,
        };
        return _this;
    }
    SliderLabeled.prototype.componentDidUpdate = function (props) {
        if (props.value !== this.props.value) {
            this.handleValueChange.cancel();
            this.setState({
                value: this.props.value,
            });
        }
    };
    SliderLabeled.prototype.render = function () {
        var _a = this.props, dataHook = _a.dataHook, disabled = _a.disabled, tooltip = _a.tooltip;
        return (React.createElement("div", { "data-aid": dataHook, "data-hook": dataHook },
            React.createElement(Composites.SliderLabeled, { automationId: dataHook },
                React.createElement(TextLabel, { value: this.props.label, automationId: dataHook ? "".concat(dataHook, "-label") : null, dataHook: dataHook ? "".concat(dataHook, "-label") : null, disabled: disabled }),
                tooltip ? React.createElement(InfoIcon, { text: tooltip }) : null,
                React.createElement(Slider, { placeholder: this.props.placeholder || '', value: this.state.value, step: this.props.step, min: this.props.min, max: this.props.max, onChange: this.handleInnerValueChange, automationId: dataHook ? "".concat(dataHook, "-slider") : null, dataHook: dataHook ? "".concat(dataHook, "-slider") : null, unit: this.props.unit, disabled: disabled }))));
    };
    return SliderLabeled;
}(React.Component));
export { SliderLabeled };
//# sourceMappingURL=SliderLabeled.js.map